import { IHttpResponse, IHttpService, IQService } from "angular";
import { Observable } from "rxjs";
import { BatchRequest, BatchRequestMethod, BatchResponse } from "./batch-request.model";
import * as angular from 'angular';

export class BatchRequestService {
	static $inject = ['$http', '$q'];
	constructor(
		private $http: IHttpService,
		private $q: IQService
	) { }

	all(requests: BatchRequest[], config: Record<string, any> = {}) {
		let deferred = this.$q.defer<IHttpResponse<BatchResponse[]>>();

		config.batchRequest = true;

		this.$http.post<BatchResponse[]>('/api/batch', requests, config).then(results => {
			results.data.forEach(result => {
				let contentType = result.headers['Content-Type'];

				if (result.headers 
					&& typeof contentType == 'string'
					&& ['application/json', 'application/hal+json'].includes(contentType)) {
					try {
						result['responseBody'] = JSON.parse(result['responseBody']);
					}
					catch (error: any) {
						console.error(error.toString())
					}
				}
			});

			deferred.resolve(results);

		},
			(errors: IHttpResponse<BatchResponse[]>) => {
				if (Array.isArray(errors.data)) {
					errors.data.forEach(error => {
						if (error.headers && error.headers["Content-Type"] == 'application/json')
							error.responseBody = JSON.parse(error['responseBody']);
					});
				}
				deferred.reject(errors);
			}
		);

		return deferred.promise;
	}
	
	observeAll(requests: BatchRequest[], config: Record<string, any> = {}) {
		return new Observable<IHttpResponse<BatchResponse[]>>(subscriber => {
			this.all(requests, config)
				.then(r => subscriber.next(r))
				.catch(err => subscriber.error(err))
				.finally(() => subscriber.complete())
		});
	}
	
	req(method: 'DELETE', uri: string): BatchRequest;
	req(method: Omit<BatchRequestMethod, 'DELETE'>, uri: string, body: object | string | null, base64?: boolean): BatchRequest
	req(method: BatchRequestMethod, uri: string, body: object | string | null = null, base64?: boolean): BatchRequest {
		let req: BatchRequest = {
			method: method,
			uri: uri,
			requestBody: ''
		};

		if (base64) {
			req['bodyIsBase64'] = true;
			req['requestBody'] = atob(body as string);
		}
		else if (typeof body == 'object')
			req['requestBody'] = JSON.stringify(body);
		else
			req['requestBody'] = body;

		return req;
	}
}

angular.module('logbook').service('batchRequest', BatchRequestService);